export default __webpack_public_path__ + "static/media/laptop.5972cef3.png";